<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon="mdi-link"
          icon-action="mdi-pencil-outline"
          :title="title"
          :subtitle="formData.value"
          v-bind="attrs"
          v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          {{ title }}
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>{{ description }}</v-card-text>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <v-text-field
              v-model="formData.value"
              outlined
          ></v-text-field>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import { mapState } from 'vuex'
import {
  TYPE_UPDATE_LOCATION_ATTR_URL_MENU,
  TYPE_UPDATE_LOCATION_ATTR_URL_ORDER_AHEAD,
  TYPE_UPDATE_LOCATION_ATTR_URL_RESERVATIONS,
  TYPE_UPDATE_LOCATION_ATTR_URL_APPOINTMENT,
  TYPE_UPDATE_LOCATION_ATTR_URL_INVENTORY_SEARCH,
} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'

export default {
  name: "LocationAttributeUrlModal",
  props: {
    title: String,
    description: String,
    bulkUpdate: Boolean,
    action: Function,
    attributeId: {
      type: String,
      required: true
    },
    value: String,
    alertScheduleTask: Array,
  },
  computed: {
    ...mapState({
      location: state => state.locations.location
    })
  },
  components: {
    LocationInfoItem,
    ScheduleForm
  },
  methods: {
    cancel: function() {
      this.open = false
      this.resetData()
    },
    resetData: function() {
      this.formData = {
        value: this.value,
        attribute_id: this.attributeId,
        schedule_start: '',
        schedule_start_at: '',
        schedule_end: '',
        schedule_end_at: '',
      }
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'attributes')
      }
    },
    callAction: async function () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.bulkUpdate) {
        this.$emit('savePayload', 'attributes', [
          {
            attribute_id: this.attributeId,
            value: this.formData.value,
          }
        ])
      } else if (this.action) {
        this.loading = true
        const payload = {
          attributes: [
            {
              attribute_id: this.attributeId,
              value: this.formData.value,
            }
          ],
          schedule_type: this.formData.schedule_type,
          schedule_start: this.formData.schedule_start,
          schedule_start_at: this.formData.schedule_start_at,
          schedule_end: this.formData.schedule_end,
          schedule_end_at: this.formData.schedule_end_at,
        }
        await this.action(payload)
        this.loading = false
      }
      this.open = false
    },
    changeScheduleDate: function(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formDataOriginal: {},
    formData: {
      schedule_type: '',
      value: null,
      attribute_id: null,
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
    },
    alertScheduledTask: null,
    attributeTypeId: ''
  }),
  beforeDestroy() {
    this.resetData()
  },
  mounted() {
    this.formData.value = this.value

    if(this.attributeId === 'url_menu') this.attributeTypeId = TYPE_UPDATE_LOCATION_ATTR_URL_MENU
    if(this.attributeId === 'url_order_ahead') this.attributeTypeId = TYPE_UPDATE_LOCATION_ATTR_URL_ORDER_AHEAD
    if(this.attributeId === 'url_reservations') this.attributeTypeId = TYPE_UPDATE_LOCATION_ATTR_URL_RESERVATIONS
    if(this.attributeId === 'url_appointment') this.attributeTypeId = TYPE_UPDATE_LOCATION_ATTR_URL_APPOINTMENT
    if(this.attributeId === 'url_inventory_search') this.attributeTypeId = TYPE_UPDATE_LOCATION_ATTR_URL_INVENTORY_SEARCH
    this.formData.schedule_type = this.attributeTypeId

    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === this.attributeTypeId) {
          this.alertScheduledTask = true;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>